<script setup lang="ts"></script>

<template>
  <button
    class="relative flex w-10 h-10 p-2 rounded-full hover:bg-stone-50 dark:hover:bg-stone-700 transition-colors duration-150 overflow-hidden cursor-pointer"
  >
    <slot></slot>
  </button>
</template>

<style scoped></style>
